module.exports = __webpack_public_path__ + "img/water-icon.f24d472f.png";